import './ResetPasswordApp.less';
import React, {useState, useEffect} from 'react';
import BeforeLoginTemplate from "../../templates/before-login/BeforeLoginTemplate";
import __ from "../../i18n";
import routes from "../../routing/routes";
import CustomForm from "../../../bootstrap/components/custom-form/CustomForm";
import Request from "../../../bootstrap/api/Request";
import Icon from "../../../bootstrap/components/icon/Icon";
import AuthResetPasswordParcel from "../../api/endpoints/auth/AuthResetPasswordParcel";
import {Link, useLocation} from "react-router-dom";


export default function ResetPasswordApp() {

    const location = useLocation();

    const query = new URLSearchParams(location.search);

    const email = query.get('email');

    const token = query.get('token');

    const [success, setSuccess] = useState(false);

    const getFieldsConfig = () => {
        return {
            password: {
                type: 'text',
                name: __('New password'),
                rules: {
                    required: true,
                    minLength: {
                        value: 6,
                        error: __('Password must contain at least ::minLength characters', {minLength: 6})
                    }
                },
                options: {
                    style: 'password',
                    passwordCanShow: true,
                    appearance: 'box',
                    placeholder: __('Enter new password')
                }
            },
            password_confirmation: {
                type: 'text',
                name: __('Confirm new password'),
                rules: {
                    required: true
                },
                options: {
                    style: 'password',
                    appearance: 'box',
                    placeholder: __('Re-enter new password')
                }
            },
        };
    };

    const getLayoutConfig = () => {
        return [
            'password',
            'password_confirmation',
        ];
    };

    const handleSubmit = (values, onSuccess, onError) => {
        if (values.password !== values.password_confirmation) {
            return onError(__('Passwords mismatch'));
        }

        Request.add(new AuthResetPasswordParcel(values.password, email, token))
            .then(data => {
                setSuccess(true);
            })
            .catch(error => {
                onError(error.getMessage());
            });
    };

    if (success) {
        return <div className="forgot-password-app">
            <BeforeLoginTemplate>
                <div className="success-block">
                    <Icon name="tick-circle"/>
                </div>
                <div className="success-title">{__('Your password has been changed successfully')}</div>
                <div className="success-message">{__('You can now login with your new password')}</div>
                <div className="divider"/>
                <div className="success-login-ask">
                    <Link className="text-link" to={routes.login.getUrl()}>{__('Back to login')}</Link>
                </div>
            </BeforeLoginTemplate>
        </div>;
    }

    return <div className="forgot-password-app">
        <BeforeLoginTemplate>
            <div className="app-title">{__('Create new password')}</div>
            <CustomForm
                fieldsConfig={getFieldsConfig()}
                layoutConfig={getLayoutConfig()}
                submit={handleSubmit}
                submitText={__('Save new password')}
                allowsSubmit={(hasChanges, values, errors) => Object.keys(errors).length === 0}
            />
        </BeforeLoginTemplate>
    </div>;
}
